export default "__VITE_ASSET__4849935b__"